import * as tslib_1 from "tslib";
import { Model } from '@app/models/model';
var BatteryOrder = /** @class */ (function (_super) {
    tslib_1.__extends(BatteryOrder, _super);
    function BatteryOrder(input) {
        return _super.call(this, input) || this;
    }
    return BatteryOrder;
}(Model));
export { BatteryOrder };
